import { useCallback, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { Page } from '@bonanza-social/navigation';
import { useSocket } from '@bonanza-social/toolkit/hooks';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { Box, Loader } from '@bonanza-social/moonlight';
import {
  fetchPrizeWall,
  updatePrizeWall,
} from '../state/prizeWall/prizeWall.slice';
import { selectPrizeWallCampaignDataState } from '../state/prizeWallCampaign/prizeWallCampaign.slice';
import { PrizeWallUpdate } from '../state/prizeWall/prizeWall.types';
import PrizeWallBackground from '../components/PrizeWallBackground/PrizeWallBackground';
import PrizeWall from '../components/PrizeWall/PrizeWall';
import PrizeWallHeader from '../components/PrizeWallHeader/PrizeWallHeader';

function PrizeWallPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const campaignDataState = useSelector(selectPrizeWallCampaignDataState);

  const onCheckWinnersPress = useCallback(() => {
    navigate('/prize-wall/winners', { replace: true });
  }, [navigate]);

  const handleInsufficientBalancePress = useCallback(() => {
    navigate('/promos');
  }, [navigate]);

  useEffect(() => {
    if (campaignDataState === 'fulfilled') {
      dispatch(fetchPrizeWall());
    }
  }, [campaignDataState, dispatch]);

  useSocket('PrizeWallUpdated', (data: PrizeWallUpdate) => {
    dispatch(updatePrizeWall(data));
  });

  return (
    <Page>
      {campaignDataState === 'pending' && <Loader margin="auto" />}
      {campaignDataState === 'rejected' && <Navigate to="/" replace />}
      {campaignDataState === 'fulfilled' && (
        <Box width="100%">
          <PrizeWallBackground contentFit="fill" />
          <Box width="100%" paddingBottom="space-600">
            <PrizeWallHeader width="100%" />
            <PrizeWall
              maxWidth={608}
              width="100%"
              margin="auto"
              onCheckWinnersPress={onCheckWinnersPress}
              onInsufficientBalancePress={handleInsufficientBalancePress}
            />
          </Box>
        </Box>
      )}
    </Page>
  );
}

export default PrizeWallPage;
